import { createAction } from '@reduxjs/toolkit';
import { IBroadcastMessagesState } from '@store/broadcast-messages/types';

export class GetMessagesFailure {
  static get action() {
    return createAction('broadcastMessages/GET_MESSAGES_FAILURE');
  }

  static get reducer() {
    return (draft: IBroadcastMessagesState) => {
      draft.requests.getBroadcastMessagesPending = false;
      return draft;
    };
  }
}
